import {DefaultPageLayout} from "./DefaultPageLayout";
import {useParams} from "react-router-dom";
import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {Button, Col, Row} from "react-bootstrap";
import {minioBaseUrl} from "../data/defaultConfig";
import {useAlbum} from "../api/albumapi";
import {useGallery} from "../api/galleryapi";

export function GalleryViewPage(props) {
    const {id} = useParams();
    const {gallery} = useGallery(id);
    const albums = gallery?.albums ? [...gallery?.albums] : []


    const albumsOrdered = albums?.sort((a1, a2) => new Date(a2.dateCreated).getTime() - new Date(a1.dateCreated).getTime())
    return <BasePageLayout title={gallery?.title}>
        <Row className={'g-0 justify-content-end'}>
            {albumsOrdered?.map(a => <AlbumItem key={a.id} album={a}/>)}
        </Row>
    </BasePageLayout>
}

function AlbumItem(props) {
    const {album} = props;
    return <Col xs={12} md={3} className={'p-2'}>
        <Button href={`/fotos/gallerij/album/${album.id}`} className={'btn-light w-100 p-0 m-0 bg-transparent text-black'}>
            <Row className={'g-0 rounded-2 shadow-lg '}>
                <Col xs={12}>
                    <Button onClick={() => {

                    }} className={'btn-light w-100 p-0 m-0 bg-transparent text-black'}>
                        <Row className={'g-0 border border-2 border-black rounded-2'} style={{
                            width: '100%',
                            height: '300px',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundImage: `url(${minioBaseUrl + album?.albumFrontFile?.url})`
                        }}>
                        </Row>
                    </Button>

                </Col>
                <Col xs={12} className={'mt-2'}>
                    <h6>{album.title}</h6>
                </Col>
            </Row>
        </Button>

    </Col>
}